import { useEffect, useSelector, useDispatch } from './basic'
import { REGISTRIES } from 'common/constants'
import { fetchRegistry } from 'store/actions'

const useAdultRatings = () => {
  const { adultRatings, loading } = useSelector(s => s.registry)
  const dispatch = useDispatch()

  useEffect(() => {
    adultRatings.length ||
      loading.includes(REGISTRIES.ADULT_RATINGS) ||
      dispatch(fetchRegistry([REGISTRIES.ADULT_RATINGS]))
  }, [])
}

export { useAdultRatings as default, useAdultRatings }
